import React, { useEffect } from "react";
import Button from "../../components/Button/Button";
import TopBar from "../../components/TopBar";
import { BiPhoneCall } from "react-icons/bi"
import { FcVideoCall } from "react-icons/fc"
import { Link, useNavigate } from "react-router-dom";
import { bookAppointmentAction, getClinicsAction } from "../../redux/actions/appointmentActions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Loading from "../../components/Loading";
import { check_token, formatter, pushNotification, generateSecureRoomName } from "../../utils";
import { toast } from "react-toastify";
import { 
  FaVideo, 
  FaCalendarAlt, 
  FaClock, 
  FaStethoscope, 
  FaStickyNote,
  FaLaptop,
  FaCheckCircle,
  FaArrowRight
} from "react-icons/fa";

export default function Online() {
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("userInfo"));
    const clinicStore = useSelector((state) => state.getClinicsAction);
    const { loading, success } = useSelector((state) => state.bookAppontment);
    const [selectVideo, setSelectVideo] = React.useState(false)
    const [selectAudio, setSelectAudio] = React.useState(false)

    const generateAppointmentUrl = () => {
        const appointmentId = `appt-${Date.now()}`;
        const secureRoomName = generateSecureRoomName(appointmentId, user.id);
        return `https://meet.misas.ng/${secureRoomName}`;
    };

    const [state, setState] = React.useState({
        appt_date: "",
        appt_time: "",
        clinic_name: "",
        clinic_id: "",
        notes: "",
        amount: 0,
        patient: user.id,
        location: user.location,
        type: "Appointment",
        appt_type: 'online',
        appt_mode: '',
        appt_url: generateAppointmentUrl()
    });
    const [selected, setSelected] = React.useState("")
    const [amount, setAmount] = React.useState(0)
    let audio_amount = JSON.parse(localStorage.getItem('consultation_audio'))?? 2500;
    let video_amount = JSON.parse(localStorage.getItem('consultation_video'))?? 5000;

    const handleChange = (e) => {
        if (e.target.name === "clinic") {
            setState({ ...state, clinic_name: e.target.options[e.target.selectedIndex].text, clinic_id: e.target.value })
            return;
        }
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const handleAudio = () => {
        setSelectAudio(true)
        setSelectVideo(false)
        setState({ ...state, amount: audio_amount, appt_mode: 'audio' })
    }
    
    const handleVideo = () => {
        setSelectVideo(true)
        setSelectAudio(false)
        setState({ ...state, amount: video_amount, appt_mode: 'video' })
    }

    const msg = (text) => {
        toast.warning(text, {
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.clinic_name === "") {
            msg("Please select a clinic");
            return;
        }
        if (state.appt_date === "") {
            msg("Please select an appointment date");
            return;
        }
        if (state.appt_time === "") {
            msg("Please select an appointment time");
            return;
        }
        if (state.amount === 0) {
            msg("Please select a mode of consultation");
            return;
        }
        // pushNotification('You have successfully booked an online appointment')
        // dispatch({ type: "BOOK_APPOINTMENT_RESET" });
        dispatch({ type: "GET_APPOINTMENT_RESET" });
        navigate("/appointment-payment", { state: { data: state } });
    };

    // Effect for initial data loading
    useEffect(() => {
        check_token();
        dispatch(getClinicsAction());
    }, [dispatch]);

    // Effect for handling booking success
    useEffect(() => {
        if (success) {
        }
        // return () => {
        //     dispatch({ type: "BOOK_APPOINTMENT_RESET" });
        //     dispatch({ type: "GET_APPOINTMENT_RESET" });
        // };
    }, [success])


    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50">
            <TopBar title={"Appointment"} url={'/first-appointment'} />
            
            {/* Tab Navigation */}
            <div className="px-4 pt-6 pb-4">
                <div className="flex bg-white rounded-xl shadow-lg p-2 max-w-md mx-auto">
                    <div className="flex-1 mr-2">
                        <Link to={'/first-appointment'}>
                            <Button 
                                text={"Hospital"} 
                                width={"full"} 
                                bg={"bg-gray-100"} 
                                textColor={"text-gray-600"}
                            />
                        </Link>
                    </div>
                    <div className="flex-1">
                        <Button
                            text={"Online"}
                            textColor={"text-white"}
                            bg={"bg-primary100"}
                            width={"full"}
                        />
                    </div>
                </div>
            </div>

            {/* Hero Section */}
            <div className="px-4 mb-6">
                <div className="bg-gradient-to-r from-purple-600 to-primary100 rounded-2xl p-6 text-white shadow-xl">
                    <div className="flex items-center mb-3">
                        <div className="bg-white/20 rounded-full p-3 mr-4">
                            <FaLaptop className="text-2xl" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold">Online Consultation</h2>
                            <p className="text-purple-100">Connect with doctors remotely</p>
                        </div>
                    </div>
                    <p className="text-purple-100 leading-relaxed">
                        Get professional medical consultation from the comfort of your home through video or audio calls.
                    </p>
                </div>
            </div>

            {/* Form Container */}
            <div className="px-4 pb-24">
                <div className="bg-white rounded-2xl shadow-xl p-6 space-y-6">
                    
                    {/* Clinic Selection */}
                    <div className="space-y-3">
                        <div className="flex items-center space-x-3">
                            <div className="bg-primary100/10 rounded-full p-2">
                                <FaStethoscope className="text-primary100 text-lg" />
                            </div>
                            <label className="text-lg font-semibold text-gray-800">Select Clinic</label>
                        </div>
                        <div className="relative">
                            <select
                                className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-primary100 focus:bg-white transition-all duration-200 appearance-none"
                                name="clinic"
                                onChange={handleChange}
                            >
                                <option value="">Choose your preferred clinic</option>
                                {clinicStore?.loading ? (
                                    <option value="">Loading clinics...</option>
                                ) : clinicStore?.error ? (
                                    <option value="">Error loading clinics. Please refresh.</option>
                                ) : clinicStore?.data?.data?.length > 0 ? (
                                    clinicStore.data.data.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                ) : (
                                    <option value="">No clinics available</option>
                                )}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none">
                                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/* Date and Time Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        
                        {/* Date Selection */}
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3">
                                <div className="bg-green-100 rounded-full p-2">
                                    <FaCalendarAlt className="text-green-600 text-lg" />
                                </div>
                                <label className="text-lg font-semibold text-gray-800">Appointment Date</label>
                            </div>
                            <div className="relative">
                                <input
                                    type="date"
                                    value={state.appt_date}
                                    name="appt_date"
                                    onChange={handleChange}
                                    className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-green-500 focus:bg-white transition-all duration-200"
                                    min={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </div>

                        {/* Time Selection */}
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3">
                                <div className="bg-blue-100 rounded-full p-2">
                                    <FaClock className="text-blue-600 text-lg" />
                                </div>
                                <label className="text-lg font-semibold text-gray-800">Appointment Time</label>
                            </div>
                            <div className="relative">
                                <input
                                    type="time"
                                    name="appt_time"
                                    onChange={handleChange}
                                    className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-blue-500 focus:bg-white transition-all duration-200"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Notes Section */}
                    <div className="space-y-3">
                        <div className="flex items-center space-x-3">
                            <div className="bg-purple-100 rounded-full p-2">
                                <FaStickyNote className="text-purple-600 text-lg" />
                            </div>
                            <label htmlFor="notes" className="text-lg font-semibold text-gray-800">
                                Additional Notes
                            </label>
                        </div>
                        <textarea
                            rows={4}
                            name="notes"
                            onChange={handleChange}
                            id="notes"
                            className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-4 text-gray-700 focus:outline-none focus:border-purple-500 focus:bg-white transition-all duration-200 resize-none"
                            placeholder="Tell us about your symptoms or any specific concerns..."
                        />
                    </div>

                    {/* Consultation Mode Selection */}
                    <div className="space-y-4">
                        <div className="flex items-center space-x-3">
                            <div className="bg-indigo-100 rounded-full p-2">
                                <FaVideo className="text-indigo-600 text-lg" />
                            </div>
                            <label className="text-lg font-semibold text-gray-800">Choose Consultation Mode</label>
                        </div>
                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {/* Audio Call Option */}
                            <div 
                                className={`relative cursor-pointer transition-all duration-200 ${
                                    selectAudio 
                                        ? 'ring-2 ring-primary100 bg-primary100/5' 
                                        : 'hover:shadow-lg hover:-translate-y-1'
                                } border-2 border-gray-200 rounded-2xl p-6 bg-white shadow-md`}
                                onClick={handleAudio}
                            >
                                {selectAudio && (
                                    <div className="absolute top-3 right-3">
                                        <FaCheckCircle className="text-primary100 text-xl" />
                                    </div>
                                )}
                                <div className="flex flex-col items-center text-center space-y-3">
                                    <div className="bg-orange-100 rounded-full p-4">
                                        <BiPhoneCall className="text-orange-600 text-3xl" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-800">Voice Call</h3>
                                        <p className="text-sm text-gray-600 mb-2">Audio consultation</p>
                                        <div className="text-2xl font-bold text-primary100">
                                            ₦{formatter.format(audio_amount)}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Video Call Option */}
                            <div 
                                className={`relative cursor-pointer transition-all duration-200 ${
                                    selectVideo 
                                        ? 'ring-2 ring-primary100 bg-primary100/5' 
                                        : 'hover:shadow-lg hover:-translate-y-1'
                                } border-2 border-gray-200 rounded-2xl p-6 bg-white shadow-md`}
                                onClick={handleVideo}
                            >
                                {selectVideo && (
                                    <div className="absolute top-3 right-3">
                                        <FaCheckCircle className="text-primary100 text-xl" />
                                    </div>
                                )}
                                <div className="flex flex-col items-center text-center space-y-3">
                                    <div className="bg-blue-100 rounded-full p-4">
                                        <FcVideoCall className="text-3xl" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-800">Video Call</h3>
                                        <p className="text-sm text-gray-600 mb-2">Face-to-face consultation</p>
                                        <div className="text-2xl font-bold text-primary100">
                                            ₦{formatter.format(video_amount)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="pt-4">
                        {loading ? (
                            <div className="flex justify-center py-4">
                                <Loading />
                            </div>
                        ) : (
                            <button 
                                className="w-full bg-gradient-to-r from-purple-600 to-primary100 hover:from-purple-600/90 hover:to-primary100/90 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center space-x-2"
                                onClick={handleSubmit}
                            >
                                <span className="text-lg">Continue to Payment</span>
                                <FaArrowRight className="text-lg" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
